import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({

  buttonReset: {
    height: '3rem',
    width: '8rem',
    fontWeight: '600',
    background: theme.palette.disabled.background,
    color: theme.palette.disabled.font,
    margin: '1rem 0',

    '&:hover': {
      background: theme.palette.disabled.hovered,
    },
  },
}));

export default useStyles;
